import React, { useCallback } from 'react';

import ProductDetailsCardComponent from 'ggApp/shared/components/cards/ProductDetailsCard';
import { SHARING_PDP_EVENTS } from 'ggApp/modules/gaAnalytics/constants';
import { Preorder } from 'ggApp/types/graphql';

interface ProductDetailsProps {
    currentVariant: {
        id: number;
        name: string;
        accent_color: string;
    };
    tooltipText: string;
    selectedRentalPlan: {
        minimumMonths: number;
        planId: number;
    };
    rentalPlans: Array<object>;
    labels: {
        productName: string;
    };
    product: {
        id: number;
        slug: string;
        sku?: string;
    };
    productCoreAttributes: string;
    productPropertiesList: Array<{ variantId: number }>;
    changeVariant: () => void;
    onCtaClick: () => void;
    promoChips: Array<{ label: string }>;
    deliveryEstimate: {
        from: string;
        to: string;
    };
    dataForSharingProduct: {
        message: string;
        link: string;
    };
    registerReferralPdpSharing: (arg1: string, arg2: string, arg3?: string) => void;
    price: string;
    oldPrice: string;
    preorderProduct: Preorder;
}

const ProductDetails = ({
    currentVariant,
    tooltipText = '',
    selectedRentalPlan,
    rentalPlans,
    labels,
    product,
    productCoreAttributes,
    productPropertiesList,
    changeVariant,
    onCtaClick,
    promoChips = [],
    deliveryEstimate,
    dataForSharingProduct = {
        link: '',
        message: '',
    },
    registerReferralPdpSharing = (): void => {},
    price,
    oldPrice,
    preorderProduct,
}: ProductDetailsProps): JSX.Element => {
    const selectedPropertyItemIndex = productPropertiesList.findIndex(
        (p) => p.variantId === currentVariant.id,
    );

    const onClickSharingCallback = useCallback(() => {
        registerReferralPdpSharing('plp', SHARING_PDP_EVENTS.enter);
    }, [registerReferralPdpSharing]);

    const onSharedSharingCallback = useCallback(
        (networkName) => {
            registerReferralPdpSharing('plp', SHARING_PDP_EVENTS.exitBySharingEvent, networkName);
        },
        [registerReferralPdpSharing],
    );

    const onCancelSharingCallback = useCallback(() => {
        registerReferralPdpSharing('plp', SHARING_PDP_EVENTS.exitByClose);
    }, [registerReferralPdpSharing]);
    return (
        <ProductDetailsCardComponent
            currentVariant={currentVariant}
            tooltipText={tooltipText}
            disableFavorites
            price={price}
            oldPrice={oldPrice}
            selectedPlan={selectedRentalPlan}
            rentalPlans={rentalPlans}
            productName={labels ? labels.productName : currentVariant.name}
            promoChips={promoChips.length > 0 ? promoChips : null}
            id={product.id}
            slug={product.slug}
            productSku={product.sku}
            productId={product.id}
            onCtaClick={onCtaClick}
            selectedPropertyItemIndex={selectedPropertyItemIndex}
            propertiesList={productPropertiesList}
            selectProductVariant={changeVariant}
            ctaTk="PRODUCT_CARD_CTA_LABEL"
            coreAttributes={productCoreAttributes}
            currentlyAvailable
            withFreeShipping
            deliveryEstimate={deliveryEstimate}
            dataForSharingProduct={dataForSharingProduct}
            callbacksForSharingProduct={{
                onClick: onClickSharingCallback,
                onShared: onSharedSharingCallback,
                onCancel: onCancelSharingCallback,
            }}
            preorderProduct={preorderProduct}
        />
    );
};

export default ProductDetails;
